// REACT DEFAULTS
import { NavLink } from 'react-router-dom'

// COMPONENTS
import { CiGrid41, CiSearch } from 'react-icons/ci'
import { BsHddStack } from 'react-icons/bs'
import { RiSettingsLine, RiShapeLine } from 'react-icons/ri'
import { TbDotsVertical } from 'react-icons/tb'
import { FiCopy } from 'react-icons/fi'

// STYLES & ASSETS
import styles from './AccountList.module.scss'
import PolarisBank from '../../assets/images/icon_polarisbank.png'
import GTBank from '../../assets/images/icon_gtbank.png'
import ProvidusBank from '../../assets/images/icon_providusbank.png'
import FirstBank from '../../assets/images/icon_firstbank.png'

const AccountList = () => {
	return (
		<section className={styles.AccountListContainer}>
			<div className={styles.AccountListHeader}>
				<p className={styles.AccountListHeaderTitle}>Your Virtual Accounts</p>

				<div className={styles.AccountListBtns}>
					<div className={styles.GridView}>
						<CiGrid41 />
					</div>
					<div className={styles.ListView}>
						<BsHddStack />
					</div>
				</div>
			</div>

			<div className={styles.searchBarContainer}>
				<p className={styles.branch}>Branch</p>
				<label className={styles.searchBarLabel} htmlFor="search">
					<input
						className={styles.searchBar}
						type="search"
						name="search"
						id="search"
						placeholder="Search for virtual account"
					/>
					<CiSearch />
				</label>
			</div>

			<div className={styles.settingContainer}>
				<p className={styles.branchName}>Lekki II</p>
				<div className={styles.settings}>
					<p className={styles.settingsTitle}>Manage</p>
					<RiSettingsLine className={styles.settingsIcon} />
				</div>
			</div>

			<div className={styles.AccountLists}>
				<div className={styles.AccountListsTitles}>
					<p className={styles.TitleItem}>Bank Name</p>
					<p className={styles.TitleItem}>Account Holder</p>
					<p className={styles.TitleItem}>Total Inflow</p>
				</div>
			</div>

			<div className={styles.AccountDetails}>
				<NavLink className={styles.BankListItem}>
					<div className={styles.BankName}>
						<img src={PolarisBank} alt="polaris" />
						{window.innerWidth > 768 && <p>Polaris Bank Limited</p>}
					</div>

					<div className={styles.BankDetails}>
						<p className={styles.AccountNumber}>08023221144</p>
						<FiCopy className={styles.Copy} />

						{window.innerWidth > 768 && (
							<div className={`${styles.BankBranch} ${styles.BankBranchOne}`}>
								<RiShapeLine />
								<small className={styles.BankBranchName}>Dodo - Ikeja</small>
							</div>
						)}
					</div>

					<div className={styles.BankInflow}>
						<p className={styles.Inflow}>NGN 100,000.00</p>
						<TbDotsVertical />
					</div>
				</NavLink>

				<NavLink className={styles.activeBorder}>
					<div className={styles.BankName}>
						<img src={GTBank} alt="polaris" />

						{window.innerWidth > 768 && <p>Guaranty Trust Holding</p>}
					</div>

					<div className={styles.BankDetails}>
						<p className={styles.AccountNumber}>08023221144</p>
						<FiCopy className={styles.Copy} />

						{window.innerWidth > 768 && (
							<div className={`${styles.BankBranch} ${styles.BankBranchTwo}`}>
								<RiShapeLine />
								<small className={styles.BankBranchName}>Dodo - Lekki II</small>
							</div>
						)}
					</div>

					<div className={styles.BankInflow}>
						<p className={styles.Inflow}>NGN 100,000.00</p>
						<TbDotsVertical />
					</div>
				</NavLink>

				<NavLink className={styles.BankListItem}>
					<div className={styles.BankName}>
						<img src={ProvidusBank} alt="polaris" />

						{window.innerWidth > 768 && <p>Providus Bank PLC</p>}
					</div>

					<div className={styles.BankDetails}>
						<p className={styles.AccountNumber}>08023221144</p>
						<FiCopy className={styles.Copy} />

						{window.innerWidth > 768 && (
							<div className={`${styles.BankBranch} ${styles.BankBranchThree}`}>
								<RiShapeLine />
								<small className={styles.BankBranchName}>Dodo - Lekki II</small>
							</div>
						)}
					</div>

					<div className={styles.BankInflow}>
						<p className={styles.Inflow}>NGN 100,000.00</p>
						<TbDotsVertical />
					</div>
				</NavLink>

				<NavLink className={styles.BankListItem}>
					<div className={styles.BankName}>
						<img src={FirstBank} alt="polaris" />

						{window.innerWidth > 768 && <p>First Bank of Nigeria</p>}
					</div>

					<div className={styles.BankDetails}>
						<p className={styles.AccountNumber}>08023221144</p>
						<FiCopy className={styles.Copy} />

						{window.innerWidth > 768 && (
							<div className={`${styles.BankBranch} ${styles.BankBranchFour}`}>
								<RiShapeLine />
								<small className={styles.BankBranchName}>Dodo - Abuja</small>
							</div>
						)}
					</div>

					<div className={styles.BankInflow}>
						<p className={styles.Inflow}>NGN 100,000.00</p>
						<TbDotsVertical />
					</div>
				</NavLink>
			</div>
		</section>
	)
}

export default AccountList
